
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABvUExURQAAAP////////////////////////////////// /////9vg66i1z+ns85KjxIudwKi20JqpyNvh66i10KGvzOLn7/Hz9/j4+5mpyPj5+/Dy97bC17fC 2MzU48XO38XN37bC2LbB19rg69Ta5wAAABMtecEAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJL R0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IyOiuV0AAADCSURBVCjP ldJtD4IgEMDxE/GhQztNQrR8qu//HZNohQ5q/V/Idr/h3DyAtYjFuIknKdiyHD2x7GkcvXGjOQZi ACkGiyAJIwMexhjsKYpNpZ2+sDyS01FsEAsXKwxgfWq8KM811arVPpQdqkq10vfauuuLHo15sBGa dCm/ftDfeHHxusNuGMdRE+n1GLodmiaaF5qcgYOCZsSFbg5+VksN5nlX7wEHFv6fCURhXNczeJX9 Wk3IvHftUq+lye52zA5m/gDQdyG5XBNgawAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQw MjozMjoxMCswMDowMMHnuWsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTAr MDA6MDCwugHXAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM1KzAwOjAw JLjQUAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    